import DonorLayout from './DonorLayout';
import ChartUtilities from './ChartUtilities';
import { ReactNode } from 'react';
//import { capitalize } from '../../lib/utils';

interface IProps {
	page: string;
	title: string | ReactNode;
	text: string | ReactNode;
	topic: string;
}
const DonorSection = ({ ...props }: IProps) => {
	return (
		<>
			<DonorLayout {...props} />
			<ChartUtilities
				component={<DonorLayout {...props} print={true} />}
				title={props.title}
				page={props.page}
			/>
		</>
	);
};

export default DonorSection;
